module.exports = __webpack_public_path__ + "img/icon-activity-note-active.e5eb3e93.svg";